/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import RegisterHook from "../hooks/RegisterHook";
import styled from "styled-components";
import {Link} from "react-router-dom";
import {AlertToast} from "../Components/AlertToast";
import {Typography} from "../Components/Typography";
import {Button} from "../Components/Button";
import {Container} from "../Components/Container";
import {FooterTipsRegisterComponents} from "./RecoveryPassword";

export const Forms = styled.form`
  border-radius: 0px 50px 0px 50px;
  box-shadow: 10px 10px 10px 5px #080808;
  margin-top: 10px;
`;

export const Input = styled.input`
  padding: 10px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: ${props => props.primary ? "palevioletred" : "#9b59b6"};
  color: #fff;
  margin: 20px;
  font-weight: bold;
`;


function Register() {
    const {
        handleRegister,
        redirectLogin,
        success,
        loading
    } = RegisterHook()

    return (
        <div className="container d-flex mt-5 flex-column align-items-center">
            <AlertToast position="top-center"/>
            <img src="logo.png" width={180} alt="Codivas" className="mb-3"/>
            {!success ? (
                    <RegisterForm handleRegister={handleRegister} loading={loading}/>
                ) : (
                    <SuccessFullRegister redirectLogin={redirectLogin}/>
                )
            }
        </div>
    );
}

export default Register;

const RegisterForm = ({handleRegister, loading}) => (
    <Forms onSubmit={handleRegister} className=" d-flex flex-column border p-5 "
           style={{height: "fit-content", textAlign: "center"}}>
        <div class="form-group d-flex flex-column justify-content-between"
             style={{height: "fit-content", border: "1px solid transparent", gap: "16px"}}>
            <p className="text-muted">Bem Vinda CODIVA!</p>
            <input className="form-control" type="email" name="email" placeholder="E-mail" required/>
            <input className="form-control" type="text" name="username" placeholder="Username" required/>
            <input className="form-control" type="password" name="password" placeholder="Password" required/>
            <Input type="submit" name="submit" value={loading || "Register"}/>
        </div>
        <FooterTipsRegisterComponents label={"Já possui uma conta?"} labelLink={"Login"} to={"/"} />
        <ul className="social-network social-circle d-flex mt-2 justify-content-around">
            <li>
                <a href="https://github.com/Codivas" className="icoGitHub" title="Github">
                    <FontAwesomeIcon icon={["fa", "code-branch"]}/>
                </a>
            </li>
            <li>
                <a href="https://www.instagram.com/coletivo.codivas/" className="icoInstagram"
                   title="Instagran">
                    <FontAwesomeIcon icon={["fa", "camera-retro"]}/>
                </a>
            </li>
        </ul>
    </Forms>
)

const SuccessFullRegister = ({redirectLogin}) => (
    <Container>
        <Typography weight={"100"} styled={"italic"} fontSize={"1.2"}>Cadastro realizado com sucesso</Typography>
        <br/><br/>
        <Button onClick={redirectLogin}>Realizar login</Button>
    </Container>
)
